<template>
    <el-dialog title="管道工单" :visible="visibleAcceptanceOrder" width="60%" @close="closeDialog"
        :close-on-click-modal="false" append-to-body>
        <div class="container">
            <!-- <div class="dynamic-cards" v-if="costData">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>费用计算详情:</span>
                    </div>
                    <div class="clearfix" v-if="costData.costDetails && costData.costDetails.length > 0">
                        <span>工费明细:</span>
                    </div>
                    <el-table v-if="costData.costDetails && costData.costDetails.length > 0"
                        :data="costData.costDetails" style="width: 100%" border>
                        <el-table-column prop="name" label="明细"></el-table-column>
                        <el-table-column prop="num" label="数量"></el-table-column>
                        <el-table-column prop="price" label="单价"></el-table-column>
                        <el-table-column prop="totalPrice" label="总价"></el-table-column>
                    </el-table>
                    <el-row>
                        <el-col :span="12">
                            <p><strong>工费合计:</strong> {{ costData.newTotal || 0 }}</p>
                        </el-col>
                    </el-row>
                    <div class="clearfix" v-if="costData.materialDetails && costData.materialDetails.length > 0">
                        <span>材料费用:</span>
                    </div>
                    <el-table v-if="costData.materialDetails && costData.materialDetails.length > 0"
                        :data="costData.materialDetails" style="width: 100%" border>
                        <el-table-column prop="name" label="明细"></el-table-column>
                        <el-table-column prop="num" label="数量"></el-table-column>
                        <el-table-column prop="price" label="单价"></el-table-column>
                        <el-table-column prop="totalPrice" label="总价"></el-table-column>
                    </el-table>
                    <el-row>
                        <el-col :span="24">
                            <p><strong>材料费合计:</strong> {{ costData.n || 0 }}</p>
                        </el-col>
                    </el-row>
                    <div class="clearfix" v-if="costData.merchantFees && costData.merchantFees.length > 0">
                        <span>商家费用:</span>
                    </div>
                    <el-table v-if="costData.merchantFees && costData.merchantFees.length > 0"
                        :data="costData.merchantFees" style="width: 100%" border>
                        <el-table-column prop="name" label="明细"></el-table-column>
                        <el-table-column prop="num" label="数量"></el-table-column>
                        <el-table-column prop="price" label="单价"></el-table-column>
                        <el-table-column prop="totalPrice" label="总价"></el-table-column>
                    </el-table>
                    <el-row>
                        <el-col :span="24">
                            <p><strong>商家总费用合计:</strong> {{ costData.y || 0 }}</p>
                        </el-col>
                    </el-row>
                    <div class="cost-summary">
                        <el-row>
                            <el-col :span="24">
                                <p><strong>实际人工费:</strong> {{ costData.laborCostFormula || 0 }}</p>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div> -->
            <!--  <div class="dynamic-cards" v-if="areaConfig && areaConfig.length > 0">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>面积电器配置:</span>
                    </div>
                    <div class="card-content">
                        <el-table :data="areaConfig" style="width: 100%" border>
                            <el-table-column prop="name" label="名称" width="100">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.name }}</span>
                                </template>
</el-table-column>
<el-table-column prop="area" label="面积(㎡)" width="100">
    <template slot-scope="scope">
                                    <span>{{ scope.row.area }}</span>
                                </template>
</el-table-column>
<el-table-column prop="productName" label="电器名称" width="650">
    <template slot-scope="scope">
                                    <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
                                </template>
</el-table-column>
</el-table>
</div>
<div style="text-align:right;margin-top:10px;font-weight:bold;">
    总面积：{{ totalArea }} ㎡
</div>
</el-card>
</div> -->
            <div class="fixed-cards" v-if="infoDetail && Object.keys(infoDetail).length > 0">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>工单基础信息:</span>
                    </div>
                    <div class="card-content">
                        <!-- <el-row>
                            <el-col :span="12">
                                <p><strong>渠道:</strong> {{ infoDetail.appointmentType }}</p>
                            </el-col>
                            <el-col :span="12">
                                <p><strong>区域:</strong> {{ infoDetail.region }}</p>
                            </el-col>
                        </el-row> -->
                        <el-row>
                            <el-col :span="24">
                                <p><strong>施工工艺:</strong> {{ infoDetail.installationForm }}</p>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <p><strong>施工地址:</strong> {{ infoDetail.customAddress }}</p>
                            </el-col>
                            <el-col :span="12">
                                <p><strong>店铺名称:</strong> {{ infoDetail.shopName }}</p>
                            </el-col>
                        </el-row>
                        <!-- consigneeMobile，consigneeName工程师姓名电话-->
                        <el-row>
                            <el-col :span="12">
                                <p><strong>工程师姓名:</strong> {{ info && info.engineerName ?
                                    info.engineerName : infoDetail.engineerName || '' }}</p>
                            </el-col>
                            <el-col :span="12">
                                <p><strong>工程师电话:</strong> {{ info && info.engineerMobile ?
                                    info.engineerMobile : '' }}</p>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <p><strong>户型:</strong> {{ infoDetail.houseType }}</p>
                            </el-col>
                            <el-col :span="12">
                                <p><strong>业主姓名:</strong> {{ infoDetail.customName }}</p>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <p><strong>业主电话:</strong> {{ infoDetail.customMobile }}</p>
                            </el-col>
                            <el-col :span="12">
                                <p><strong>业务员:</strong> {{ infoDetail.salesperson }}</p>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <div class="fixed-cards" v-if="dynamicColumns.length > 0">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>工单详情:</span>
                    </div>
                    <div class="card-content">
                        <el-row >
                            <el-col v-for="column in dynamicColumns" :key="column.id"
                                style="display: flex;align-items: center;text-align: center;"
                                :span="getSpan(dynamicColumns.length)">
                                <strong>{{ column.fieldName }}:</strong>
                                <span v-if="['input', 'checkbox', 'radio'].includes(column.inputType)">{{
                                    column.fieldValue }}</span>
                                <!-- 评分星级 -->
                                <span v-else-if="column.inputType === 'star'"
                                    style="display: flex;align-items: center;text-align: center;">
                                    <el-rate v-model="column.fieldValue" disabled></el-rate>
                                    <span>{{ column.fieldValue == '1' ? '差' : column.fieldValue == '2' ? '一般' :
                                        column.fieldValue == '3' ? '好' : column.fieldValue == '4' ? '很好' :
                                            column.fieldValue
                                                == '5' ? '非常好' : '' }}</span>
                                </span>
                                <span v-else><time>{{ column.fieldValue }}</time></span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24" v-if="totalPrice">
                                <p style="font-weight: bold;color: #ff4949;">工程师费用合计: {{ totalPrice }}</p>
                            </el-col>
                        </el-row>
                        <el-row v-if="dynamicColumns.length === 0">
                            <el-col :span="24">
                                <p>暂无数据</p>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="imageFields.length > 0">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>工单清单图片信息:</span>
                    </div>
                    <div class="form-row" v-for="column in imageFields" :key="column.id">
                        <p class="gap-line-border" v-if="column.inputType === 'img'">
                            <span class="nameStyle">{{ column.fieldName }}:</span>
                            <span class="gap-line"></span>
                            <span v-if="column.fieldValue">
                                <viewer :images="formmaterImage(column.fieldValue)">
                                    <img v-for="src in formmaterImage(column.fieldValue)" :src="src" :key="src"
                                        class="card-image" />
                                </viewer>
                            </span>
                            <span v-else>暂无图片</span>
                        </p>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="info.signUrl">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>验收签名:</span>
                    </div>
                    <div class="form-row">
                        <p class="gap-line-border">
                            <span class="nameStyle">签名时间：{{ info.signTime }}</span>
                            <span class="gap-line"></span>
                            <span v-if="info.signUrl">
                                <viewer :images="formmaterImage(info.signUrl)">
                                    <img :src="info.signUrl" class="card-image" />
                                </viewer>
                            </span>
                            <span v-else>暂无图片</span>
                        </p>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="historyReasons">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>历史退回原因:</span>
                    </div>
                    <div class="form-row" v-for="(remark, index) in historyReasons.split(',')" :key="index">
                        <p class="gap-line-border">
                            <span> <span class="nameStyle">第{{ index + 1 }}次退回原因:</span>{{ remark }}</span>
                            <span class="gap-line"></span>
                        </p>
                    </div>
                </el-card>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button type="text" icon="el-icon-printer" size="small" plain
                v-if="info.status == 'TO_BE_EVALUATED' || info.status == 'COMPLETE'"
                @click="showCostInput">打印商家费用</el-button> -->
            <el-button type="text" icon="el-icon-check" size="small" plain v-if="info.status == 'TO_BE_THE_FINAL'"
                @click.stop="pass()">通过</el-button>
            <el-button type="text" icon="el-icon-close" size="small" plain v-if="info.status == 'TO_BE_THE_FINAL'"
                @click.stop="refuse()">拒绝</el-button>
            <el-button v-if="info.status != 'TO_BE_THE_FINAL'" type="text" size="small" icon="el-icon-close" plain
                @click="closeDialog">关闭</el-button>
        </span>
        <el-dialog title="输入代金券" :visible.sync="showCostInputdialog" width="30%" append-to-body
            :close-on-click-modal="false">
            <el-form :model="costData" ref="costForm" label-width="120px">
                <el-form-item label="代金券金额" prop="voucher">
                    <el-input v-model="costData.voucher" type="number" min="0" placeholder="请输入代金券金额" />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="primary" @click="confirmCostInput">确认</el-button>
                <el-button @click="cancelCostInput">取消</el-button>
            </span>
        </el-dialog>
    </el-dialog>
</template>
<script>
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
import { passOrRefusedAcceptance, findCustomsDeclaration, getEngineerAreaConfig, calculateCost, recordPrintCount } from "@/api/work/pipeline/merchants";
import { findEngineeringOrder, getEngineerInfo } from "@/api/work/eliveryOrder";
import { DIC } from "@/const/dic";
import { formatterTime } from "@/util/util";
export default {
    name: "ViewServiceDiary",
    props: {
        visibleAcceptanceOrder: {
            type: Boolean,
            required: true,
        },
        orderId: {
            type: [String, Number],
            required: true,
        },
        evaluateInfo: {
            type: Boolean,
            default: false,
        },
        infoDetail: {
            type: Object,
            default: () => ({}),
        },
        totalPrice: {
            type: Number,
            default: 0,
        },
        id: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            tableData: [], // 存放固定字段数据
            dynamicColumns: [], // 存放动态字段列数据
            imageFields: [], // 存放动态图片字段数据
            inputTypes: [], // 获取动态控件类型
            type: '',
            areaConfig: [], // 添加面积配置数据
            info: {},
            historyReasons: '',
            customsData: null,
            totalArea: '',
            costData: {
                voucher: 0,
            }, // 存放费用计算数据
            loadingCost: false, // 费用计算加载状态
            showCostInputdialog: false, // 打印商家费用弹窗
        };
    },
    computed: {
    },
    created() {
        // 初始加载时如果 orderId 已经有值，调用 handleList
        if (this.orderId) {
            // 获取动态控件类型
            findDataSourceFields().then(res => {
                let data = JSON.parse(res.data);
                this.inputTypes = data;
                // 获取产品数据
                const orderId = this.orderId; // 假设产品ID通过路由参数传递
                if (orderId) {
                    this.fetchGoodsData(orderId);
                    // this.findCustomsDeclaration();
                    // this.getCostData(this.id);
                }
            }).catch(err => {
                // this.$message.error('获取动态控件类型失败', err);
            });
        }
    },
    watch: {
        /**
         * 
         * @param newVal 
         * @description 监听 visibleAcceptanceOrder 的变化
         * @returns void
         */
        visibleAcceptanceOrder(newVal) {
            // 同步到父组件
            this.$emit('update:visibleAcceptanceOrder', newVal);
            if (newVal && this.orderId) {
                // 获取动态控件类型
                findDataSourceFields().then(res => {
                    let data = JSON.parse(res.data);
                    this.inputTypes = data;
                    // 获取产品数据
                    const orderId = this.orderId; // 假设产品ID通过路由参数传递
                    if (orderId) {
                        this.fetchGoodsData(orderId);
                        // this.findCustomsDeclaration();
                        this.costData = { voucher: 0 };
                        // this.getCostData(this.id);
                    }
                }).catch(err => {
                    // this.$message.error('获取动态控件类型失败', err);
                });
            }
        }
    },
    methods: {
        // 获取费用计算数据
        getCostData(orderId) {
            this.loadingCost = true;
            calculateCost(orderId).then(res => {
                if (res.code === "200" && res.data) {
                    try {
                        this.costData = JSON.parse(res.data);
                    } catch (e) {
                        // this.$message.error('数据格式错误');
                    }
                } else {
                    // this.$message.error(res.message);
                }
            }).catch(error => {
                // this.$message.error('获取费用计算失败');
            }).finally(() => {
                this.loadingCost = false;
            });
        },
        pass() {
            this.$confirm("确认通过？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = { ...this.info }
                    data.status = 'TO_BE_EVALUATED';
                    passOrRefusedAcceptance(data).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.closeDialog();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        refuse() {
            this.$prompt("请输入拒绝原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    let data = { ...this.info }
                    data.status = 'IN_SERVICE';
                    data.reason = this.historyReasons ? this.historyReasons + ',' + value : value;
                    passOrRefusedAcceptance(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.closeDialog();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: "提交出错",
                        type: "error",
                    });
                });
        },
        findCustomsDeclaration() {
            findCustomsDeclaration(this.id).then(res => {
                if (res.code === "200") {
                    this.customsData = JSON.parse(res.data);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        /**
         * 
         * @param orderId 工单ID
         * @description 获取工单数据
         * @returns void
         */
        fetchGoodsData(orderId) {
            const params = {
                id: orderId,
                code: 'PIPELINE'
            };
            findEngineeringOrder(this.orderId).then(res => {
                if (res.code == "200") {
                    const data = JSON.parse(res.data).rows[0];
                    data.signTime = data.signTime ? formatterTime(data.signTime) : '';
                    this.info = data;
                    if (data.reason) {
                        this.historyReasons = data.reason;
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            });
            // 获取产品数据
            evaluateInfoView(params).then(res => {
                if (res.code == "200") {
                    const jsonData = JSON.parse(res.data); // 解析返回的 JSON 数据
                    // 将图片字段单独处理
                    const imageFields = jsonData.list.filter(item => item.inputType == '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.value
                    }));
                    this.imageFields = imageFields;
                    // 其他字段
                    const dynamicColumns = jsonData.list.filter(item => item.inputType != '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.dataType.word == 'star' ? parseInt(item.value) : item.value
                    }));
                    this.dynamicColumns = dynamicColumns;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).catch(err => {
                // this.$message.error('获取数据失败', err);
            });
            // 获取面积电器配置
            getEngineerAreaConfig({
                declarationId: this.infoDetail.id,
                declarationFlag: 1
            }).then(res => {
                if (res.code === "200") {
                    this.areaConfig = JSON.parse(res.data);
                } else {
                    this.$message.error(res.message);
                }
            });
            //获取工程师信息，先检查 infoDetail 和 deliveryOrderId 是否存在
            if (this.infoDetail && this.infoDetail.deliveryOrderId) {
                getEngineerInfo(this.infoDetail.deliveryOrderId).then(res => {
                    if (res.code == "200") {
                        // 确保 infoDetail 存在后再设置 engineerInfo
                        if (!this.infoDetail) {
                            this.infoDetail = {};
                        }
                        this.infoDetail.engineerInfo = JSON.parse(res.data) || {};
                    } else {
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                });
            }
        },
        /**
         * 
         * @param length 
         * @description 动态计算每列的span值
         * @returns number
         */
        getSpan(length) {
            // 动态计算每列的span值
            return Math.floor(24 / Math.min(length, 3)); // 最多3列
        },
        /**
         * 
         * @param row 
         * @description 格式化图片字段
         * @returns Array
         */
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        /**
         * 
         * @param inputType 
         * @description 获取输入类型的名称
         * @returns string
         */
        getInputType(inputType) {
            const item = this.inputTypes.find(type => type.id == inputType);
            return item ? item.word : ''; // 返回输入类型的名称
        },
        /**
         * 
         * @param status 
         * @description 获取状态的名称
         * @returns string
         */
        getStatusLabel(status) {
            const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
            return statusItem ? statusItem.label : status;
        },
        /**
         * 
         * @description 关闭弹窗
         * @returns void
         */
        closeDialog() {
            // 清空弹窗数据
            this.tableData = [];
            this.dynamicColumns = [];
            this.imageFields = [];
            this.info = {};
            this.historyReasons = '';
            this.customsData = null;
            this.showCostInputdialog = false;
            this.costData = { voucher: 0 };
            // 通过 emit 事件让父组件关闭弹窗
            this.$emit('close');
        },
        showCostInput() {
            if (!this.costData) {
                this.costData = {
                    voucher: 0
                };
            } else if (!this.costData.voucher) {
                this.costData.voucher = 0;
            }
            this.showCostInputdialog = true;
        },
        cancelCostInput() {
            // 清除代金券数据
            if (this.costData) {
                this.costData.voucher = 0;
            }
            this.showCostInputdialog = false;
            this.$nextTick(() => {
                if (this.$refs.costForm) {
                    this.$refs.costForm.clearValidate();
                }
            });
        },
        confirmCostInput() {
            if (this.costData && this.costData.voucher > 0) {
                // 验证通过，提交数据
                this.showCostInputdialog = false;
                this.printMerchantFees();
            } else {
                this.printMerchantFees();
            }
        },
        // 打印商家费用
        printMerchantFees() {
            if (!this.costData || !this.costData.merchantFees || this.costData.merchantFees.length === 0) {
                this.$message.warning('暂无商家费用数据');
                return;
            }
            // 创建打印窗口
            const printWindow = window.open('', '_blank');
            // 构建打印内容
            let printContent = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <style>
                        * {
                            margin: 0;
                            padding: 0;
                            box-sizing: border-box;
                        }
                        body {
                            font-family: "SimHei", "黑体", sans-serif;
                            font-size: 12pt;
                            line-height: 1.4;
                            color: #000;
                            background: #fff;
                        }
                        .print-container {
                            width: 100%;
                            max-width: 210mm;
                            margin: 0 auto;
                            padding: 12mm;
                            box-sizing: border-box;
                        }
                        .header {
                            text-align: center;
                        }
                        .header h1 {
                            font-size: 16pt;
                            font-weight: bold;
                            margin-bottom: 4mm;
                            font-family: "SimHei", "黑体", sans-serif;
                        }
                        .basic-info {
                            margin-bottom: 5mm;
                        }
                        .info-row {
                            display: flex;
                            margin-bottom: 4mm;
                            align-items: center;
                            line-height: 1.4;
                        }
                        .info-item {
                            flex: 1;
                            font-size: 13pt;
                        }
                        .info-label {
                            font-weight: bold;
                            min-width: 80px;
                            font-size: 13pt;
                        }
                        .table-container {
                            margin-bottom: 2mm;
                        }
                        .table-container h2 {
                            font-size: 12pt;
                            font-weight: bold;
                            margin-bottom: 1mm;
                            text-align: center;
                            font-family: "SimHei", "黑体", sans-serif;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-bottom: 2mm;
                        }
                        th, td {
                            border: 1px solid #000;
                            padding: 2mm;
                            text-align: center;
                            font-size: 12pt;
                            line-height: 1.3;
                        }
                        th {
                            font-weight: bold;
                            font-family: "SimHei", "黑体", sans-serif;
                        }
                        .total-row {
                            font-weight: bold;
                        }
                        .footer {
                            text-align: right;
                            font-size: 12pt;
                        }
                        @media print {
                            @page {
                                size: A4;
                                margin: 2mm;
                            }
                            body {
                                font-size: 12pt;
                            }
                            .header h1 {
                                font-size: 16pt;
                            }
                            .table-container h2 {
                                font-size: 12pt;
                            }
                            th, td {
                                font-size: 12pt;
                            }
                            .info-item,
                            .info-label {
                                font-size: 12pt;
                            }
                            .footer {
                                font-size: 12pt;
                            }
                            .print-container {
                                page-break-inside: avoid;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-container">
                        <div class="header">
                            <h1>销售出库单</h1>
                        </div>
                        <div class="basic-info">
                            <div class="info-row">
                               <div class="info-item">
                                    <span class="info-label">客户简称:</span> ${this.info.abbreviation || '无'}
                                </div> 
                                 <div class="info-item">
                                    <span class="info-label">报单编号:</span> ${this.infoDetail.number || '无'}
                                </div>
                            </div>
                            <div class="info-row"> 
                                <div class="info-item">
                                    <span class="info-label">客户全称:</span> ${this.infoDetail.shopName || '无'}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">户型:</span> ${this.infoDetail.houseType || '无'}
                                </div>
                            </div>
                            <div class="info-row"> 
                                <div cl <div class="info-item">
                                    <span class="info-label">报单时间:</span> ${this.info.createTime ? this.formatterTime(this.info.createTime) : '无'}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">交付时间:</span> ${this.info.submitTime ? this.formatterTime(this.info.submitTime) : '无'}
                                </div>
                            </div>
                            <div class="info-row">
                                 <div class="info-item">
                                    <span class="info-label">交付地址:</span> ${this.infoDetail.customAddress || '无'}
                                </div>
                            </div>
                        </div>
                        <div class="table-container">
                            <table>
                                <thead>
                                    <tr>
                                        <th>序号</th>
                                        <th>项目</th>
                                        <th>单位</th>
                                        <th>数量</th>
                                        <th>单价</th>
                                        <th>金额</th>
                                        <th>备注</th>
                                    </tr>
                                </thead>
                                <tbody>
            `;
            const unitMap = {
                '面积': '平方',
                '二次上门': '次',
                '不满10平方按不足的平方补贴费用': '平方',
                '包梁异形': '平方',
                '增项': '其它',
                '未安装电器房间增收': '平方',
            }
            // 添加商家费用数据
            this.costData.merchantFees.forEach(item => {
                printContent += `
                    <tr>
                        <td>${this.costData.merchantFees.indexOf(item) + 1}</td>
                        <td>${item.name || ''}</td>
                        <td>${unitMap[Object.keys(unitMap).find(key => item.name.includes(key))] || item.unit || '无'}</td>
                        <td>${item.num || 0}</td>
                        <td>${item.price || 0}</td>
                        <td>${item.totalPrice || 0}</td>
                        <td>${item.remark || ''}</td>
                    </tr>
                `;
            });
            // 添加合计行
            printContent += `
                                <tr class="total-row">
                                    <td colspan="5">费用合计:${this.numberToUpperCase(this.costData.y || 0)}</td>
                                    <td>${this.costData.y || 0}</td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                         <div class="footer" style="text-align: left;">
                            <p>${this.costData && this.costData.voucher && this.costData.voucher > 0 ? '摘要: 代金券' + (this.costData.voucher || 0) + ',实收金额' + ((this.costData.y || 0) - (this.costData.voucher || 0)) : ''}</p>
                        </div>
                        <div class="footer">
                            <p>打印时间: ${new Date().toLocaleString()}</p>
                        </div>
                    </div>
                </body>
                </html>
            `;
            // 写入打印内容并打印
            printWindow.document.write(printContent);
            printWindow.document.close();
            // 等待页面加载完成后打印
            printWindow.onload = function () {
                printWindow.print();
                // 打印完成后关闭窗口
                setTimeout(() => {
                    printWindow.close();
                }, 1000);
            };
            // 打印完成后清除代金券数据
            this.$nextTick(() => {
                if (this.costData) {
                    this.costData.voucher = 0;
                }
                if (this.$refs.costForm) {
                    this.$refs.costForm.clearValidate();
                }
            });
            // 调用后端API记录打印次数
            this.recordPrintCount();
        },
        // 记录打印次数
        recordPrintCount() {
            // 伪代码：后端API调用
            // 实际项目中应替换为真实的API调用
            const printRecordApi = {
                // 记录打印次数的API方法
                recordPrint: (orderId) => {
                    return new Promise((resolve) => {
                        // 模拟API请求
                        setTimeout(() => {
                            resolve({ code: '200', message: '记录成功' });
                        }, 500);
                    });
                }
            };
            // 调用API记录打印次数
            printRecordApi.recordPrint(this.id).then(res => {
                if (res.code === '200') {
                    // 可以根据需要添加成功提示
                } else {
                    // 可以根据需要添加失败提示
                }
            }).catch(err => {
            });
        },
        // 金额数字转大写
        numberToUpperCase(money) {
            // 1. 基础校验和格式化
            if (money === '' || money === null || money === undefined) return '零元整';
            // 转换为数字并处理非数字情况
            let num = Number(money);
            if (isNaN(num)) return '无效金额';
            // 处理负数（实际场景中金额一般为正，这里转为正数并标注）
            let isNegative = false;
            if (num < 0) {
                isNegative = true;
                num = Math.abs(num);
            }
            // 保留两位小数（金额精确到分）
            num = num.toFixed(2);
            // 2. 定义大写数字和单位
            const digitChinese = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
            const unit = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟', '万']; // 万万亿（覆盖常用金额范围）
            const decimalUnit = ['角', '分'];
            // 3. 拆分整数和小数部分
            const [integerPart, decimalPart] = num.split('.');
            let integerStr = '';
            let decimalStr = '';
            // 4. 处理整数部分
            if (integerPart !== '0') {
                // 去除整数部分前置零，然后转为数组处理每一位
                const integerArr = integerPart.replace(/^0+/, '').split('');
                const len = integerArr.length;
                // 遍历每一位数字
                for (let i = 0; i < len; i++) {
                    const digit = parseInt(integerArr[i]);
                    const pos = len - 1 - i; // 当前位的单位位置
                    // 处理零的情况（避免连续零、末尾零）
                    if (digit === 0) {
                        // 只有当前位不是最后一位，且下一位不是零时，才加零
                        if (i < len - 1 && parseInt(integerArr[i + 1]) !== 0) {
                            integerStr += digitChinese[0];
                        }
                    } else {
                        integerStr += digitChinese[digit] + unit[pos];
                    }
                }
            } else {
                // 整数部分为0时，直接写零
                integerStr = digitChinese[0];
            }
            integerStr += '元';
            // 5. 处理小数部分（角、分）
            if (decimalPart === '00') {
                // 无小数时加“整”
                decimalStr = '整';
            } else {
                const jiao = parseInt(decimalPart[0]);
                const fen = parseInt(decimalPart[1]);
                if (jiao !== 0) {
                    decimalStr += digitChinese[jiao] + decimalUnit[0];
                } else if (fen !== 0) {
                    // 角为0但分为非0时，补零
                    decimalStr += digitChinese[0];
                }
                if (fen !== 0) {
                    decimalStr += digitChinese[fen] + decimalUnit[1];
                }
            }
            // 6. 拼接结果，处理负数
            let result = integerStr + decimalStr;
            if (isNegative) {
                result = '负' + result;
            }
            return result;
        },
        // 格式化时间
        formatterTime(time) {
            if (!time) return '';
            const date = new Date(time);
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
    },
};
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}
.fixed-cards,
.dynamic-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}
.clearfix {
    font-weight: bold;
}
.gap-line-border {
    padding: 0 10px;
    border: 1px dashed #ccc;
}
.gap-line {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}
.nameStyle {
    font-weight: bold;
    line-height: 4px;
}
.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
}
.card:hover {
    transform: scale(1.01);
}
.dynamic-cards:last-child {
    margin-bottom: 30px;
}
.card-content {
    padding: 20px;
    font-family: fangsong;
    word-break: break-word;
    /* 自动换行 */
}
.card p {
    margin: 10px 0;
    line-height: 1.6;
    word-break: break-word;
    /* 自动换行 */
}
.card strong {
    color: #333;
}
.card .el-image {
    border-radius: 5px;
}
.card-image {
    width: 100px;
    height: 100px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}
.cost-summary {
    margin-top: 20px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 5px;
    font-size: 14px;
}
.cost-summary p {
    margin: 5px 0;
}
.form-row p {
    flex: 1;
    min-width: calc(20% - 10px);
    /* 每行三个内容，减去间隙 */
    box-sizing: border-box;
    margin: 0;
}
.dynamic-cards .card {
    width: 100%;
}
@media (max-width: 768px) {
    .card {
        width: 100%;
    }
    .form-row {
        flex-direction: column;
    }
    .form-row p {
        min-width: 100%;
        /* 小屏幕下每行一个内容 */
    }
}
</style>